// @flow
import { gql, useMutation } from '@apollo/client';

type UseCancelPendingDeployment = () => {
  cancelPendingDeployment: (string) => void
}

const useCancelPendingDeployment: UseCancelPendingDeployment = () => {
  const [__cancelPendingDeployment] = useMutation(MUTATION, {
    refetchQueries: [
      'getPendingDeployment'
    ]
  });
  const cancelPendingDeployment = (pageId) => __cancelPendingDeployment({
    variables: { pageId }
  });

  return {
    cancelPendingDeployment
  };
};

const MUTATION = gql`
mutation cancelPendingDeployment($pageId: ID!) {
  cancelPendingDeployment(pageId: $pageId) {
    _id
  }
}
`;

export default useCancelPendingDeployment;
